module.exports = __webpack_public_path__ + "static/media/halal-my.6d965e80.png";